import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsCanceledOrdersEnum } from '../../enums/stocks/columns-canceled-orders.enum'

export const ColumnsCanceledOrdersConstant: ColumnInterface<ColumnsCanceledOrdersEnum>[] = [
	{
		column: ColumnsCanceledOrdersEnum.tickerCompany,
		visible: true,
	},
	{
		column: ColumnsCanceledOrdersEnum.operation,
		visible: true,
	},
	{
		column: ColumnsCanceledOrdersEnum.quantity,
		visible: true,
	},
	{
		column: ColumnsCanceledOrdersEnum.price,
		visible: true,
	},
	{
		column: ColumnsCanceledOrdersEnum.orderType,
		visible: true,
	},
	{
		column: ColumnsCanceledOrdersEnum.executed,
		visible: true,
	},
	{
		column: ColumnsCanceledOrdersEnum.orderStatus,
		visible: true,
	},
]
